import some from 'lodash/some';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import css from './loader.module.scss';

function isFetchingState(state) {
  return some(Object.values(state), 'isFetching');
}

function mapStateToProps(state) {
  // TODO: LoginWithAlexaDialog.js is current Loader directly.
  // If partners state is ever used to show the loader,
  // there is a possiblity of two loaders showing up on the Devices page.
  const isFetching =
    isFetchingState(state) ||
    isFetchingState(state.users) ||
    isFetchingState(state.categories) ||
    isFetchingState(state.profiles) ||
    isFetchingState(state.products) ||
    isFetchingState(state.search) ||
    isFetchingState(state.me) ||
    isFetchingState(state.subscription) ||
    isFetchingState(state.subscriptionFlow);
  return {
    isFetching,
  };
}

export const BaseLoader = () => (
  <div className={css.container} data-testid="loader">
    <div className={css.loader}></div>
  </div>
);

export function Loader({ isFetching }) {
  return isFetching && <BaseLoader />;
}

Loader.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Loader);
